// extracted by mini-css-extract-plugin
module.exports = {"title":"FuneralHomeForm_title__3QXRx","field":"FuneralHomeForm_field__zHqcX","label":"FuneralHomeForm_label__28lx1"};